import {
  GET_LABREQUESTINCIDENT_FAIL,
  GET_LABREQUESTINCIDENT_SUCCESS,
  GET_LABREQUESTINCIDENTS_FAIL,
  GET_LABREQUESTINCIDENTS_SUCCESS,
  ADD_LABREQUESTINCIDENT_SUCCESS,
  ADD_LABREQUESTINCIDENT_FAIL,
  UPDATE_LABREQUESTINCIDENT_SUCCESS,
  UPDATE_LABREQUESTINCIDENT_FAIL,
  DELETE_LABREQUESTINCIDENT_SUCCESS,
  DELETE_LABREQUESTINCIDENT_FAIL,  
  SET_STATE_LABREQUESTINCIDENT
} from "./actionTypes";

const INIT_STATE = {
  labRequestIncidents: [],
  labRequestIncident: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestIncidents = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTINCIDENTS_SUCCESS:
      return {
        ...state,
        labRequestIncidents: action.payload.labRequestIncidents,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTINCIDENT:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTINCIDENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTINCIDENT_SUCCESS:
      return {
        ...state,
        labRequestIncidents: [...state.labRequestIncidents, action.payload],
      };

    case ADD_LABREQUESTINCIDENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTINCIDENT_SUCCESS:
      return {
        ...state,
        labRequestIncidents: state.labRequestIncidents.map(labRequestIncident =>
          labRequestIncident.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestIncident }
            : labRequestIncident
        ),
      };

    case UPDATE_LABREQUESTINCIDENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTINCIDENT_SUCCESS:
      return {
        ...state,
        labRequestIncidents: state.labRequestIncidents.filter(
          labRequestIncident => labRequestIncident.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTINCIDENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTINCIDENT_SUCCESS:
      return {
        ...state,
        labRequestIncident: action.payload,
      };

    case GET_LABREQUESTINCIDENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestIncidents;
